(function () {
  let closeDrawer = null;

  function initFilterDrawer() {
    const drawer = document.getElementById('filter-drawer');
    const overlay = document.querySelector('.filter-drawer__overlay');
    const trigger = document.querySelector('.collection-grid-header__filter-trigger');
    const closeButton = drawer ? drawer.querySelector('.filter-drawer__close') : null;
    const clearAllButton = document.getElementById('FilterDrawerClearAll');
    const applyButton = document.getElementById('FilterDrawerApply');

    if (!drawer || !overlay || !trigger) return;

    gsap.set(drawer, { xPercent: 100 });

    function open() {
      const tl = gsap.timeline();
      tl.to(drawer, {
        xPercent: 0,
        duration: 0.6,
        ease: 'power2.out',
      }).to(
        overlay,
        {
          opacity: 1,
          pointerEvents: 'auto',
          duration: 0.4,
        },
        '<',
      );
      trigger.setAttribute('aria-expanded', 'true');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('menu-open');
    }

    function close() {
      const tl = gsap.timeline();
      tl.to(drawer, {
        xPercent: 100,
        duration: 0.6,
        ease: 'power2.out',
      }).to(
        overlay,
        {
          opacity: 0,
          pointerEvents: 'none',
          duration: 0.4,
        },
        '<',
      );
      trigger.setAttribute('aria-expanded', 'false');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('menu-open');
    }

    closeDrawer = close;

    trigger.addEventListener('click', () => {
      trigger.getAttribute('aria-expanded') === 'true' ? close() : open();
    });

    overlay.addEventListener('click', close);
    closeButton?.addEventListener('click', close);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') close();
    });

    function setPillState(pill, active) {
      pill.setAttribute('aria-pressed', active ? 'true' : 'false');
    }

    drawer.querySelectorAll('.filter-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        setPillState(pill, pill.getAttribute('aria-pressed') !== 'true');
      });
    });

    function buildSearchParams() {
      const params = new URLSearchParams();
      drawer.querySelectorAll('.filter-pill[aria-pressed="true"]').forEach((pill) => {
        params.append(pill.dataset.paramName, pill.dataset.value);
      });
      return params;
    }

    function applyFilters() {
      if (!applyButton) return;

      const collectionUrl = applyButton.dataset.collectionUrl;
      const productGrid = document.getElementById('product-grid');
      if (!collectionUrl || !productGrid) return;

      const sectionId = productGrid.dataset.id;
      const params = buildSearchParams().toString();
      const fetchUrl = `${collectionUrl}?section_id=${sectionId}${params ? `&${params}` : ''}`;

      return fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const newGridContainer = parsedHTML.getElementById('ProductGridContainer');
          const currentGridContainer = document.getElementById('ProductGridContainer');

          if (newGridContainer && currentGridContainer) {
            currentGridContainer.innerHTML = newGridContainer.innerHTML;
          }

          history.pushState({}, '', `${collectionUrl}${params ? `?${params}` : ''}`);
        });
    }

    applyButton?.addEventListener('click', () => {
      applyFilters().then(close);
    });

    clearAllButton?.addEventListener('click', () => {
      drawer.querySelectorAll('.filter-pill').forEach((pill) => setPillState(pill, false));
      applyFilters().then(close);
    });
  }

  initFilterDrawer();

  if (typeof barba !== 'undefined') {
    barba.hooks.beforeLeave(() => closeDrawer?.());
  }

  document.addEventListener('page:loaded', initFilterDrawer);
})();
